import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  ${borderRadius.r3}
  border: 1px solid var(--border-soft);
  background: var(--background-soft);
  display: flex;
  padding: 4px;
  margin-bottom: 20px;
  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2}
  }
`;
